import React from "react";
import { motion } from "framer-motion";
import { Star, Award, Clock, MapPin } from "lucide-react";
import { IMAGES } from "../config";

const WhyChooseUs = () => {
  const features = [
    { icon: <Star size={24} />, title: "5-Star Service", desc: "Expert bartenders delivering exceptional experiences at every event." },
    { icon: <Award size={24} />, title: "Award Winning", desc: "2026 Hitched Wedding Awards winner. Trusted by hundreds of couples." },
    { icon: <Clock size={24} />, title: "Flexible Packages", desc: "From cash bars to all-inclusive. We tailor to your budget and style." },
    { icon: <MapPin size={24} />, title: "UK Wide", desc: "Based in Cambridgeshire & West Midlands. We travel across the country." }
  ];

  return (
    <section className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <p className="text-[#a5dae0] font-script text-2xl mb-4">Why Bar Spot?</p>
            <h2 className="text-4xl md:text-5xl mb-6">Your Event, Our Expertise</h2>
            <p className="text-[#666666] text-lg leading-relaxed mb-8">
              Established in 2020, Bar Spot was created with a vision to provide an unrivaled mobile bar experience.
              We specialize in bespoke mobile bar hire, offering premium drinks at reasonable prices.
            </p>
            <div className="grid grid-cols-2 gap-6">
              {features.map((feature, i) => (
                <div key={i} className="flex gap-4">
                  <div className="text-[#a5dae0]">{feature.icon}</div>
                  <div>
                    <h4 className="font-semibold text-[#1a1a1a]">{feature.title}</h4>
                    <p className="text-sm text-[#666666]">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src={IMAGES.cocktail}
                alt="Bartender preparing cocktails at a mobile bar hire event"
                className="w-full h-[500px] object-cover"
                loading="lazy"
              />
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-[#1a1a1a]/80 to-transparent">
                <div className="flex items-center gap-4">
                  <img
                    src="https://cdn1.hitched.co.uk/img/badges/2026/badge-weddingawards_en_GB.jpg"
                    alt="Hitched 2026 Wedding Awards winner — Bar Spot Ltd"
                    className="h-16 w-auto"
                    loading="lazy"
                  />
                  <div>
                    <p className="text-white font-semibold">Award Winner</p>
                    <p className="text-white/80 text-sm">2026 Hitched Wedding Awards</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
